import type { RouteRecordRaw } from 'vue-router';
import IndexPage from '@/views/home/index.vue';
import SettingPage from '@/views/setting/index.vue';
import I18nPage from '@/views/i18n/index.vue';
import DashboardPage from '@/views/dashboard/index.vue';
import DemoPage from '@/views/demo/index.vue';
import qs from 'qs';
const commonRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'home',
    },
    component: IndexPage,
  },
  {
    path: '/im',
    name: 'home',
    meta: {
      title: 'im',
    },
    beforeEnter: async (to, from, next) => {
      debugger;
      const messageHandler = window.__MESSAGE_HANDLER as any;
      const hash = (to.hash || '').replace(/^#\/?\?/g, '');
      const query = qs.parse(hash);
      await messageHandler.openPage({
        appCode: 'im',
        params: query,
      });
      next();
    },
    component: IndexPage,
  },
  {
    path: '/titsetting',
    name: 'titsetting',
    meta: {
      title: 'setting',
    },
    component: SettingPage,
  },
  {
    path: '/i18n',
    name: 'i18n',
    meta: {
      title: 'i18n',
    },
    component: I18nPage,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: 'dashboard',
    },
    component: DashboardPage,
  },
  {
    path: '/demo',
    name: 'demo',
    meta: {
      title: 'DEMO',
    },
    component: DemoPage,
  },
];

export default commonRoutes;
